import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

import Auth from 'components/Auth';
import logo from 'images/stork.svg';
import Strings from 'components/Strings';
import './header.css';

const styles = {
  menuButton: {
  },
  hide: {
    visibility: 'hidden',
  }
};

class Header extends Component {
  handleShowSidebar = () => {
    const { onShowSidebarClicked } = this.props;
    onShowSidebarClicked && onShowSidebarClicked();
  }

  render() {
    const { showSidebar, classes } = this.props;

    return (
      <header className="Header">
        <div>
          <IconButton
            aria-label="Show Sidebar"
            onClick={ this.handleShowSidebar }
            className={ classnames(classes.menuButton, showSidebar && classes.hide) }
          >
            <MenuIcon />
          </IconButton>
        </div>
        <h1 className="Header-title">
          <Link to="/">
            <img src={ logo } alt={ <Strings label="profile_picture" /> } style={{ width: '100px' }} />
            <span><Strings label="app_title" /></span>
          </Link>
        </h1>
        <Auth />
      </header>
    );
  }
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js